'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CardAction = function CardAction(_ref) {
    var href = _ref.href,
        className = _ref.className,
        children = _ref.children,
        label = _ref.label,
        onClick = _ref.onClick;
    return _react2.default.createElement("a", { className: (0, _classnames2.default)('luna-card__action', className), href: href, onClick: onClick }, label, children);
};
CardAction.propTypes = {
    onClick: _propTypes2.default.func.isRequired,
    className: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.string), _propTypes2.default.string]).isRequired,
    href: _propTypes2.default.string.isRequired,
    label: _propTypes2.default.string.isRequired,
    children: _propTypes2.default.string.isRequired
};
exports.default = CardAction;
//# sourceMappingURL=CardAction.js.map